import { render } from "./book.vue?vue&type=template&id=10fe7fd3"
const script = {}

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/icons/book.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "10fe7fd3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('10fe7fd3', __exports__)) {
    api.reload('10fe7fd3', __exports__)
  }
  
  module.hot.accept("./book.vue?vue&type=template&id=10fe7fd3", () => {
    api.rerender('10fe7fd3', render)
  })

}


export default __exports__